import React, { useState } from "react";
import { LifeBuoy, PhoneCall } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

export default function UrgentHelp({ trigger }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ subject: "", phone: "", description: "", preferred_time: "" });
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const submit = async () => {
    if (!f.subject) { toast.error("Merci d'indiquer le sujet"); return; }
    try {
      await api.post("/callbacks", { ...f, priority: "urgent" });
      toast.success("Demande envoyée. Nous vous rappelons rapidement.");
      setOpen(false); setF({ subject: "", phone: "", description: "", preferred_time: "" });
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  return (
    <>
      {trigger ? React.cloneElement(trigger, { onClick: () => setOpen(true) }) : (
        <Button variant="outline" className="border-rose-200 text-rose-700 bg-rose-50 hover:bg-rose-100" onClick={() => setOpen(true)} data-testid="urgent-help-btn">
          <LifeBuoy className="h-4 w-4 mr-1.5" />Besoin d'aide ?
        </Button>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><PhoneCall className="h-5 w-5 text-rose-600" />Demander à être rappelé rapidement</DialogTitle>
            <DialogDescription>Notre équipe vous recontacte dans les meilleurs délais.</DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <div><Label>Sujet *</Label><Input value={f.subject} onChange={(e) => set("subject", e.target.value)} className="mt-1" data-testid="urgent-subject" /></div>
            <div><Label>Téléphone</Label><Input value={f.phone} onChange={(e) => set("phone", e.target.value)} placeholder="Laissez vide pour utiliser votre numéro" className="mt-1" /></div>
            <div><Label>Description</Label><Textarea rows={3} value={f.description} onChange={(e) => set("description", e.target.value)} className="mt-1" data-testid="urgent-description" /></div>
            <div><Label>Moment préféré pour le rappel</Label><Input value={f.preferred_time} onChange={(e) => set("preferred_time", e.target.value)} placeholder="Ex : aujourd'hui après 14h" className="mt-1" /></div>
            <p className="text-xs text-amber-700 bg-amber-50 border border-amber-100 rounded-lg p-3">Cette fonction concerne vos demandes administratives auprès de notre équipe. Elle ne doit pas être utilisée pour une urgence médicale.</p>
          </div>
          <DialogFooter><Button className="bg-primary" onClick={submit} data-testid="urgent-submit">Me rappeler rapidement</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
